import React from "react";

interface Props {
  isLarge: boolean;
  ratingValue: number;
}
interface State {
}

class Rating extends React.Component<Props, State> {
  constructor(props) {
    super(props);
  }
  render() {
    const { isLarge, ratingValue } = this.props;
    const valueStyle = {
      transform: `scaleX(${ratingValue / 5})`
    };
    return (
      <span className={`rating ${isLarge ? "is-large" : ""}`}>
        <span className="rating__average">{ratingValue.toFixed(1)}</span>{" "}
        <span className="rating__stars">
          <span className="rating__value" style={valueStyle} />
        </span>
      </span>
    );
  }
}

export default Rating;
